<template>
  <div>
    <div class="wrapper" :style="{width: width + 'px', height: height + 'px'}">
      <canvas ref="signaturePad" class="signature-pad" :width="width" :height="height" :style="'background: url(' + stamp + ') center center / cover no-repeat;'">
        Your browser does not support the canvas element.
      </canvas>
      <canvas id="canvas"></canvas>
      <input @change="checkFile()" ref="input" type="file" id="signature" class="input-file" accept="image/x-png">
    </div>
    <div>
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script>

'use strict'

import SignaturePad from 'signature_pad'

export default {

  name: 'VueSignaturePad',

  props:
  {
    background: {
      type: String,
      default: 'rgba(255, 255, 255, 0)',
      required: false
    },
    color: {
      type: String,
      default: 'rgba(0,0,0,0.87)',
      required: false
    },
    width: {
      type: Number,
      default: 400,
      required: false
    },
    height: {
      type: Number,
      default: 200,
      required: false
    },
    format: {
      type: String,
      default: 'image/png',
      required: false
    },
    maxFileSize: {
      type: Number,
      default: 200000,
      required: false
    }
  },

  data: () => ({
    signature: null,
    stamp: ''
  }),

  mounted () {
    this.signaturePad = new SignaturePad(
      this.$refs.signaturePad, {
        backgroundColor: this.background,
        penColor: this.color
      }
    )
  },

  methods:
  {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    save () {
      let signatureImage = this.signaturePad.toDataURL(this.format)

      if (this.stamp === '') {
        return this.$emit('on-save-signature', signatureImage)
      }
      var canvas = document.getElementById('canvas')
      var context = canvas.getContext('2d')
      let signature = new Image()
      let stamp = new Image()

      let self = this
      signature.onload = function () {
        canvas.width = self.width
        canvas.height = self.height
        stamp.src = self.stamp
      }
      stamp.onload = function () {
        context.drawImage(signature, 0, 0)
        context.drawImage(stamp, 0, 0)
        self.$emit('on-save-signature', canvas.toDataURL('image/png'))
        context.clearRect(0, 0, self.width, self.height)
      }
      signature.src = signatureImage
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    clear () {
      this.signaturePad.clear()
      this.stamp = ''
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    checkFile () {
      let file = this.$refs.input.files[0]
      let reader = new FileReader()
      reader.readAsDataURL(file)

      let self = this
      reader.addEventListener('load', function () {
        let img = new Image()

        img.onload = () => {
          if (file.type !== self.format) {
            self.$emit('on-upload-error', 'format', self.format)
          } else if (file.size > self.maxFileSize) {
            self.$emit('on-upload-error', 'max-file-size', self.maxFileSize)
          } else if (img.width !== self.width) {
            self.$emit('on-upload-error', 'width', self.width)
          } else if (img.height !== self.height) {
            self.$emit('on-upload-error', 'height', self.height)
          } else {
            self.stamp = reader.result
          }
        }
        img.src = reader.result
      }, false)
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    selectSignatureFile () {
      this.$refs.input.value = ''
      this.$refs.input.click()
    }
  }
}
</script>

<style lang="sass" scoped>
#canvas
  display: none

.wrapper
  position: relative
  -moz-user-select: none
  -webkit-user-select: none
  -ms-user-select: none
  user-select: none
  margin: 0 auto

img
  position: absolute
  left: 0
  top: 0

.signature-pad
  position: absolute
  left: 0
  top: 0
  border: 2px dashed #ccc

.input-file
    display: none
</style>



// WEBPACK FOOTER //
// src/components/vue-signature-pad.vue